<script setup lang="ts">
import type { Tag } from '@blog/types'

defineProps<{
  tag: Tag
  reverse?: boolean
}>()
</script>

<template>
  <span
    :class="reverse ? 'text-neutral-50 bg-primary-500 dark:bg-primary-200 border-1 border-transparent' : 'text-neutral-900 hover:text-neutral-50'"
    inline-block py-2px px-8px rounded-32px border
    dark:text-neutral-900
    hover:dark:text-neutral-900
    hover:bg-primary-500 hover:dark:bg-primary-300 transition-all cursor-pointer border-neutral-300
    line-clamp-0 paragraph-xs font-500 w-fit mt-2px mx-3px
  >
    {{ tag.title }}
  </span>
</template>
